if (!customElements.get('cart-shipping-details')) {
  customElements.define(
    'cart-shipping-details',
    class CartShippingDetails extends HTMLElement {
      connectedCallback() {
        this.initializeShippingLocationType();
        this.updateShippingLocationsField();
      }

      get localPickupType() {
        return this.querySelector('[data-shipping-location-type]');
      }

      get shippingLocationsField() {
        return this.querySelector('[data-shipping-locations-field]');
      }

      get shippingLocationsSelect() {
        return this.querySelector('[data-shipping-locations-select]');
      }

      get shippingLocationsAttributeName() {
        return this.dataset.shippingLocationsAttribute;
      }

      get isLocalPickupType() {
        return this.localPickupType?.value === 'local_pickup';
      }

      isSavedValueLocation() {
        const savedValue = this.dataset.shippingLocationsValue;
        if (!savedValue || savedValue === 'local_pickup' || savedValue === 'shipping') {
          return false;
        }

        return Boolean(
          this.shippingLocationsSelect?.querySelector(`option[value="${CSS.escape(savedValue)}"]`)
        );
      }

      shouldShowLocationsField() {
        return this.isLocalPickupType || this.isSavedValueLocation();
      }

      initializeShippingLocationType() {
        const typeSelect = this.localPickupType;
        const savedValue = this.dataset.shippingLocationsValue;
        if (!typeSelect || !savedValue) return;

        if (savedValue === 'local_pickup' || savedValue === 'shipping') {
          typeSelect.value = savedValue;
          return;
        }

        if (this.isSavedValueLocation()) {
          typeSelect.value = 'local_pickup';
        }
      }

      setShippingLocationsValue(value) {
        this.dataset.shippingLocationsValue = value;
      }

      updateShippingLocationsField() {
        const wrapper = this.shippingLocationsField;
        const select = this.shippingLocationsSelect;
        if (!wrapper || !select) return;

        const showLocationsField = this.shouldShowLocationsField();

        wrapper.classList.toggle('hidden', !showLocationsField);
        select.disabled = !showLocationsField;
        select.required = showLocationsField;

        if (!showLocationsField) {
          select.value = '';
          return;
        }

        const savedValue = this.dataset.shippingLocationsValue;
        if (savedValue && select.querySelector(`option[value="${CSS.escape(savedValue)}"]`)) {
          select.value = savedValue;
        }
      }

      updateShippingLocationAttribute(value) {
        const attributeName = this.shippingLocationsAttributeName;
        if (!attributeName) return;

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              [attributeName]: value || null,
            },
          }),
        });
      }

      clearShippingLocationAttribute() {
        this.setShippingLocationsValue('');
        this.updateShippingLocationAttribute(null);
      }
    }
  );

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-shipping-location-type]')) {
      const value = event.target.value;

      document.querySelectorAll('[data-shipping-location-type]').forEach((select) => {
        select.value = value;
      });

      document.querySelectorAll('cart-shipping-details').forEach((details) => {
        details.setShippingLocationsValue(value);
        details.updateShippingLocationsField();
      });

      if (value !== 'local_pickup') {
        document.querySelectorAll('[data-shipping-locations-select]').forEach((select) => {
          select.value = '';
        });
      }

      document.querySelector('cart-shipping-details')?.updateShippingLocationAttribute(value);

      return;
    }

    if (!event.target.matches('[data-shipping-locations-select]')) return;

    const value = event.target.value;

    document.querySelectorAll('[data-shipping-locations-select]').forEach((select) => {
      select.value = value;
    });

    document.querySelectorAll('cart-shipping-details').forEach((details) => {
      details.setShippingLocationsValue(value);
    });

    document.querySelector('cart-shipping-details')?.updateShippingLocationAttribute(value);
  });
}
